import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Wordmark, DgcEmblem } from "./Logo";
import { useAuth, ROLE_HOME } from "../context/AuthContext";
import { DIVISIONS } from "../lib/heritage";

const media = DIVISIONS[0].items.map(([n, , , s]) => [n, `/entities/${s}`]);
const business = DIVISIONS.slice(1).flatMap((d) => d.items).map(([n, , , s]) => [n, `/entities/${s}`]);

const COLS = [
  ["Explore DESPITE", [["Home", "/"], ["History", "/history"], ["The Principals", "/principals"], ["Organisation", "/organisation"], ["The Future", "/future"], ["Live Hub", "/hub"]]],
  ["Leadership", [["Dr. Osei Kwame Despite", "/people/osei-kwame-despite"], ["Dr. Ernest Ofori Sarpong", "/people/ernest-ofori-sarpong"], ["Kennedy Osei", "/people/kennedy-osei"]]],
  ["Media · Listen & Watch Live", media],
  ["Businesses", business],
  ["Shop & Partners", [["DGC Marketplace", "/shop"], ["Product lines", "/shop#lines"], ["Where to buy", "/shop#where"], ["Order online", "/shop#lines"], ["Become a supplier / distributor", "/shop#partners"]]],
  ["Work & Connect", [["Careers", "/careers"], ["Track my application", "/careers#pool"], ["Join talent community", "/careers#pool"], ["Museum visit", "/entities/despite-automobile-museum"], ["Feedback", "/hub#news"]]],
];

export const MegaMenu = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const loc = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [loc.pathname, loc.hash]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);
  const item = ([l, to]) => {
    const cls = "block py-1.5 text-[15px] text-white/85 hover:text-[color:var(--gold-hi)] transition-colors";
    const tid = `menu-link-${l.toLowerCase().replace(/\W+/g, "-")}`;
    return to.includes("#") ? <a key={l + to} href={to} className={cls} data-testid={tid} onClick={() => setOpen(false)}>{l}</a> : <Link key={l + to} to={to} className={cls} data-testid={tid}>{l}</Link>;
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="w-11 h-11 rounded-md flex items-center justify-center bg-brand-green text-white border-b-2 border-[color:var(--gold-hi)] hover:bg-brand-deep transition-colors" aria-label="Open menu" data-testid="burger-menu-btn"><Menu size={22} /></button>
      {open && createPortal(
        <div className="fixed inset-0 z-[100] bg-brand-deep overflow-y-auto" data-testid="mega-menu">
          <div className="kente" />
          <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3"><DgcEmblem size={42} /><Wordmark light /></Link>
            <button onClick={() => setOpen(false)} className="w-11 h-11 rounded-md flex items-center justify-center bg-brand-green text-white" aria-label="Close menu" data-testid="burger-close-btn"><X size={22} /></button>
          </div>
          <div className="max-w-7xl mx-auto px-5 md:px-8 py-10 grid sm:grid-cols-2 lg:grid-cols-6 gap-8">
            {COLS.map(([t, links]) => (
              <div key={t} className="rise" data-testid={`menu-col-${t.toLowerCase().replace(/\W+/g, "-")}`}>
                <div className="font-data text-[10px] uppercase tracking-[0.25em] gold-text mb-4 pb-2 border-b border-[color:var(--gold-hi)]/40">{t}</div>
                {links.map(item)}
              </div>
            ))}
          </div>
          <div className="max-w-7xl mx-auto px-5 md:px-8 pb-12 flex flex-wrap gap-3">
            <Link to={user ? ROLE_HOME[user.role] : "/login"} className="btn-gold !bg-[color:var(--gold-hi)] !text-[#064D29]" data-testid="menu-portal-btn">{user ? "My Portal" : "Staff Login"}</Link>
            <Link to="/shop" className="btn-ghost" data-testid="menu-shop-btn">Shop DGC products</Link>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};
